import React from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import Carousel from '../components/common/Carousel';
import { heroMain, exitReadyHero, scalePathHero } from '../assets/images/imageImports';

const Home = () => {
  return (
    <div className="home-page">
      <Hero
        title="SkySight Analytics"
        subtitle="Empowering businesses with data-driven solutions for growth and successful exits"
        buttonText="Learn More"
        buttonLink="/why-exit-ready"
        secondaryButtonText="Contact Us"
        secondaryButtonLink="/contact"
        backgroundImage={heroMain}
      />
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Solutions</h2>
          
          <Carousel>
            <div className="carousel-item">
              <img src={exitReadyHero} alt="ExitReady Solution" className="carousel-image" />
              <div className="carousel-content">
                <h3>SkySight ExitReady™</h3>
                <p className="tagline">Own Your Numbers. Command Your Valuation.</p>
                <p>Preparing for a sale? The best exits aren't reactive—they're built on clean, credible data that withstands scrutiny. SkySight ExitReady™ is your turnkey data preparation service that gives your company the clarity, control, and confidence needed to sail through due diligence and maximize value.</p>
                <div className="carousel-button-container">
                  <Button to="/why-exit-ready" type="primary">Learn About ExitReady™</Button>
                </div>
              </div>
            </div>
            
            <div className="carousel-item">
              <img src={scalePathHero} alt="ScalePath Solution" className="carousel-image" />
              <div className="carousel-content">
                <h3>SkySight ScalePath™</h3>
                <p className="tagline">Build the finance and data foundation to scale with confidence.</p>
                <p>SkySight ScalePath™ is a finance and data stack advisory program purpose-built for high-growth private equity portfolio firms and companies. Acting as fractional operating partners we help leadership teams expedite the timeline to, choose and operationalize the systems, processes, and insights needed to scale effectively without the corresponding headcount.</p>
                <div className="carousel-button-container">
                  <Button to="/whats-included" type="primary">Explore ScalePath™</Button>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
      </section>
      
      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Who We Serve</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">Founder-Led Firms</h3>
              <p>Preparing to scale-up, M&A work, or operational efficiencies.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">PE-Backed Companies</h3>
              <p>Portfolio companies seeking clean exit paths with minimal data risk or building scalable infrastructure for growth.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">M&A Advisors - Sell Side</h3>
              <p>Recent funding and need to scale-up, increase reporting capabilities.</p>
            </div>
          </div>
          <div className="text-center" style={{marginTop: '2rem'}}>
            <Button to="/who-its-for" type="secondary" size="large">See Who We Serve</Button>
          </div>
        </div>
      </section>
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Why SkySight Analytics?</h2>
          <div className="row">
            <div className="col-6">
              <ul className="check-list">
                <li>Deep experience in finance + data across dozens of success stories</li>
                <li>Built for small to mid-cap companies scaling fast or preparing for sale</li>
                <li>We implement systems, not just strategy</li>
                <li>Flexible engagement models and hands-on execution</li>
                <li>We speak founder, CFO, and board fluently</li>
              </ul>
            </div>
            <div className="col-6">
              <div className="testimonial">
                <p className="testimonial-text">"SkySight Analytics transformed our financial data infrastructure, making our exit process smooth and helping us secure a premium valuation."</p>
                <p className="testimonial-author">— CEO, Technology Company</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;